import React, { useMemo, createContext } from "react";
import { Provider } from "urql";
import { client } from "./support/graphqlApi";
import Page from "./components/Page";
import { useAtom } from "jotai";
import { logoutAtom } from "./support/atoms";
import { ThirdwebProvider } from "thirdweb/react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getTheme } from "./theme";
import { NotificationComponent } from "./hooks/useNotification";
import { themeAtom } from "./atoms/themeAtom";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

const App = () => {
  const [, logout] = useAtom(logoutAtom);
  const [mode, setMode] = useAtom(themeAtom);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    [setMode]
  );

  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider value={client(logout)}>
          {window.location.host.includes("localhost") ? (
            <Box sx={{ height: "100vh", width: "100vw", p: 0 }}>
              <ThirdwebProvider>
                <Page />
              </ThirdwebProvider>
              <NotificationComponent />
            </Box>
          ) : (
            <Box sx={{ height: "100vh", width: "100vw" }}>
              <Page />
              <NotificationComponent />
            </Box>
          )}
        </Provider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
